export const LOCALSTORAGE_TTL = 1000 * 60 * 5; // 5 minute
export const INIT_HANDSHAKE = 'klarna_initialize_messenger_handshake';
export const INIT_HANDSHAKE_COMPLETE = 'klarna_initialize_messenger_handshake_complete';
export const ALLOWED_MESSAGE_ORIGIN_HOSTNAME_PATTERN = /(\.klarna\.com|\.klarna\.net|^x\.klarnacdn\.net)$/u;
